import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { hasUnsavedChangesState } from '~/state/atoms/patientAtoms';

/**
 * Arms a `beforeunload` prompt while unsaved changes exist, so closing the
 * tab or navigating away cannot silently discard clinical work. Browsers
 * show their own generic wording; the in-app leave paths keep their
 * specific confirmation dialogs.
 */
export function useUnsavedChangesGuard(): void {
    const hasUnsavedChanges = useRecoilValue(hasUnsavedChangesState);

    useEffect(() => {
        if (!hasUnsavedChanges) {
            return;
        }
        const handler = (event: BeforeUnloadEvent): void => {
            event.preventDefault();
            // Chrome requires returnValue to be set for the prompt.
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return () => {
            window.removeEventListener('beforeunload', handler);
        };
    }, [hasUnsavedChanges]);
}
